module.exports = __webpack_public_path__ + "img/13-1.1b0ce1a9.png";